import type { ValuesUnion } from "@regrello/core-utils";

export const RegrelloShape = {
  CIRCLE: "circle" as const,
  RECTANGLE: "rectangle" as const,
};

export type RegrelloShape = ValuesUnion<typeof RegrelloShape>;
